import React, { useState } from 'react'
import { Modal, ModalOverlay } from '@apexinternal/ui-components'
import { Box, Flex, Icon, Link, Text, useDisclosure } from '@chakra-ui/react'
import { values as createArray, without } from 'lodash'
import { FaRegEdit } from 'react-icons/fa'
import { Addresses } from 'types/CommonTypes'
import ConfirmModalContent from './ConfirmModalContent'
import EditModalContent from './EditModalContent'

export interface UpdateAddressModalProps {
  accountNumber: string
  accountAddress: Addresses
}

const initialValues = {
  mailingAddress: {
    streetAddress: [],
    city: '',
    state: '',
    postalCode: '',
    country: '',
  },
  homeAddress: {
    streetAddress: [],
    city: '',
    state: '',
    postalCode: '',
    country: '',
  },
}

const UpdateAddressForm = ({
  accountNumber,
  accountAddress,
}: UpdateAddressModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [hideHomeAddress, setHomeAddress] = useState<boolean>(true)
  const [confirmationView, setConfirmationView] = useState<boolean>(false)
  const [payload, setPayload] = useState<Addresses>(initialValues)
  const [editedAddress, setEditedAddress] = useState<any>({
    mailingAddress: accountAddress,
  })

  const closeAndClear = () => {
    setPayload(initialValues)
    setEditedAddress({ mailingAddress: accountAddress })
    setHomeAddress(true)
    onClose()
    setConfirmationView(false)
  }

  const loadEditModalContent = () => {
    setConfirmationView(false)
  }

  const formatResponse = (values: any) => {
    values.mailingAddress.streetAddress = without(
      createArray(values.mailingAddress.streetAddress),
      '',
      undefined
    )
    values.mailingAddress.country = 'USA'

    if (values.homeAddress && !hideHomeAddress) {
      values.homeAddress.streetAddress = without(
        createArray(values.homeAddress.streetAddress),
        '',
        undefined
      )
      values.homeAddress.country = 'USA'
      setPayload({
        mailingAddress: values.mailingAddress,
        homeAddress: values.homeAddress,
      })
      setEditedAddress({
        mailingAddress: values.mailingAddress,
        homeAddress: values.homeAddress,
      })
    } else {
      setPayload({
        mailingAddress: values.mailingAddress,
      })
      setEditedAddress({ mailingAddress: values.mailingAddress })
    }
  }

  return (
    <Box>
      <Link
        align="right"
        color="blue.500"
        onClick={onOpen}
        data-testid="update-address-link"
      >
        <Flex>
          <Icon as={FaRegEdit} marginRight="0.357rem" />
          <Text>Update</Text>
        </Flex>
      </Link>
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        {confirmationView && (
          <ConfirmModalContent
            accountNumber={accountNumber}
            content={payload}
            homeIsSame={hideHomeAddress}
            loadEditModalContent={loadEditModalContent}
            onClose={closeAndClear}
          />
        )}
        {!confirmationView && (
          <EditModalContent
            accountAddress={editedAddress}
            accountNumber={accountNumber}
            formatResponse={formatResponse}
            setHomeAddress={setHomeAddress}
            setConfirmationView={setConfirmationView}
            onClose={closeAndClear}
            hideHomeAddress={hideHomeAddress}
          />
        )}
      </Modal>
    </Box>
  )
}

export default UpdateAddressForm
